import {
    MessagesSquare,
    BookOpen,
    Mic,
    AudioWaveform,
    Volume2,
    Sparkles,
    Eye,
    MessageCircle,
    Ear,
    Users,
    Heart,
    User,
    Focus,
    Smile,
    Target,
    TrendingUp,
    Search,
    Home,
    Lightbulb,
    Repeat,
    CalendarCheck,
    HelpCircle,
    ListChecks,
    PenLine,
    HandHeart,
} from "lucide-react";

const ICONS = {
    MessagesSquare,
    BookOpen,
    Mic,
    AudioWaveform,
    Volume2,
    Sparkles,
    Eye,
    MessageCircle,
    Ear,
    Users,
    Heart,
    User,
    Focus,
    Smile,
    Target,
    TrendingUp,
    Search,
    Home,
    Lightbulb,
    Repeat,
    CalendarCheck,
    HelpCircle,
    ListChecks,
    PenLine,
    HandHeart,
};

export const Icon = ({ name, ...props }) => {
    const Cmp = ICONS[name] || Sparkles;
    return <Cmp {...props} />;
};
